import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const SelectDropdown = () => {
  const [value1, setValue1] = useState("option1");

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* BASIC SELECTS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Basic Selects</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Default Select</label>
            <select value={value1} onChange={(e) => setValue1(e.target.value)} className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded text-slate-100 focus:border-amber-400 focus:ring-1 focus:ring-amber-400">
              <option value="option1">Option 1</option>
              <option value="option2">Option 2</option>
              <option value="option3">Option 3</option>
            </select>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<select className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded">
  <option value="1">Option 1</option>
  <option value="2">Option 2</option>
</select>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">With Label</label>
            <div>
              <label className="text-xs text-slate-300 font-medium mb-1 block">Choose Category</label>
              <select className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded text-slate-100">
                <option>Electronics</option>
                <option>Clothing</option>
                <option>Books</option>
              </select>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<label className="text-xs font-medium mb-1 block">Choose</label>
<select className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded">
  <option>Electronics</option>
</select>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">With Groups</label>
            <select className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded text-slate-100">
              <optgroup label="Fruits">
                <option>Apple</option>
                <option>Banana</option>
              </optgroup>
              <optgroup label="Vegetables">
                <option>Carrot</option>
                <option>Broccoli</option>
              </optgroup>
            </select>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<select className="w-full px-3 py-2...">
  <optgroup label="Fruits">
    <option>Apple</option>
  </optgroup>
</select>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Multiple Select</label>
            <select multiple className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded text-slate-100 h-24">
              <option>Python</option>
              <option>JavaScript</option>
              <option>React</option>
              <option>Vue</option>
            </select>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<select multiple className="w-full px-3 py-2 bg-slate-800 h-24">
  <option>Python</option>
  <option>JavaScript</option>
</select>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Disabled</label>
            <select disabled className="w-full px-3 py-2 bg-slate-700 border border-slate-600 rounded text-slate-500 cursor-not-allowed">
              <option>Disabled</option>
            </select>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<select disabled className="w-full px-3 py-2 bg-slate-700 border border-slate-600 rounded text-slate-500 cursor-not-allowed">
  <option>Disabled</option>
</select>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">With Icon</label>
            <div className="relative">
              <select className="w-full px-3 py-2 pr-8 bg-slate-800 border border-slate-600 rounded text-slate-100 appearance-none">
                <option>Select an option</option>
                <option>Option A</option>
                <option>Option B</option>
              </select>
              <span className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-slate-400"></span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative">
  <select className="w-full px-3 py-2 pr-8 appearance-none...">
  <span className="absolute right-2..."></span>
</div>`} />
          </div>
        </div>
      </div>

      {/* STYLED VERSIONS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-blue-400 mb-6"> Styled Variants</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Cyan Accent</label>
            <select className="w-full px-3 py-2 bg-slate-800 border-2 border-amber-500 rounded text-slate-100 focus:border-amber-400">
              <option>Cyan Option 1</option>
              <option>Cyan Option 2</option>
            </select>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<select className="w-full px-3 py-2 bg-slate-800 border-2 border-amber-500 rounded">`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Purple Accent</label>
            <select className="w-full px-3 py-2 bg-slate-800 border-2 border-amber-500 rounded text-slate-100">
              <option>Purple Option 1</option>
              <option>Purple Option 2</option>
            </select>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<select className="w-full px-3 py-2 bg-slate-800 border-2 border-amber-500 rounded">`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Rounded Full</label>
            <select className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded-full text-slate-100">
              <option>Rounded Selection</option>
              <option>Option</option>
            </select>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<select className="w-full px-3 py-2 bg-slate-800 rounded-full">`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">With Shadow</label>
            <div className="p-1 bg-gradient-to-r from-amber-500 to-blue-500 rounded">
              <select className="w-full px-3 py-2 bg-slate-800 text-slate-100 rounded">
                <option>Shadow Select</option>
              </select>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-1 bg-gradient-to-r from-amber-500 to-blue-500 rounded">
  <select className="w-full px-3 py-2 bg-slate-800 rounded">
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Large Size</label>
            <select className="w-full px-4 py-3 text-lg bg-slate-800 border border-slate-600 rounded text-slate-100">
              <option>Large Selection</option>
            </select>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<select className="w-full px-4 py-3 text-lg bg-slate-800 border border-slate-600 rounded">`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Small Size</label>
            <select className="w-full px-2 py-1 text-sm bg-slate-800 border border-slate-600 rounded text-slate-100">
              <option>Small Selection</option>
            </select>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<select className="w-full px-2 py-1 text-sm bg-slate-800 border border-slate-600 rounded">`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectDropdown;


